// Single source of truth for the backend base URL.
// Override per-environment with REACT_APP_API_URL (see .env.example);
// falls back to the deployed server so a plain `npm start` just works.
export const API_URL =
  process.env.REACT_APP_API_URL || "https://demoserver-yfrh.onrender.com";
